<section class="links-shell">
  @if (error) {
    <p class="error">{{ error }}</p>
  }

  @if (sites.length) {
    <section class="table-panel">
      <header class="table-panel-header">
        <div>
          <p class="eyebrow">References</p>
          <h2>Links</h2>
          <p class="table-note">Open a link to update its destination, context, or score.</p>
        </div>
        <button type="button" class="accent" [disabled]="loading || !!deletingLinkId" (click)="createLink()">New link</button>
      </header>

      @if (tagFilter.tags.length) {
        <section class="active-filters-band" aria-label="Applied link filters">
          <div class="active-filters-copy">
            <p class="active-filters-label">Filters</p>
            <div class="active-filters-list">
              @for (tag of tagFilter.tags; track tag) {
                <button
                  type="button"
                  class="content-tag tag-filter-chip is-active"
                  [disabled]="loading || !!deletingLinkId"
                  [attr.aria-pressed]="true"
                  (click)="toggleTagFilter(tag)">
                  {{ tag }}
                </button>
              }
            </div>
          </div>
          <button
            type="button"
            class="ghost small clear-filters-button"
            [disabled]="loading || !!deletingLinkId"
            (click)="clearFilters()">
            Clear all
          </button>
        </section>
      }

      @if (loading) {
        <p class="empty-state">Loading links...</p>
      } @else if (links.length) {
        <div class="table-wrap">
          <table>
            <thead>
              <tr>
                <th scope="col">Headline</th>
                <th scope="col">URL</th>
                <th scope="col">Tags</th>
                <th scope="col">Rating</th>
                <th scope="col">Action</th>
              </tr>
            </thead>
            <tbody>
              @for (link of links; track link.id) {
                <tr>
                  <td class="title-cell">
                    <div class="link-primary">
                      <strong class="headline-text" [title]="link.headline || 'Untitled link'">{{ link.headline || 'Untitled link' }}</strong>
                    </div>
                  </td>
                  <td class="url-cell"><code class="url-text" [title]="link.url">{{ link.url }}</code></td>
                  <td class="tags-cell">
                    @if (link.tags.length) {
                      <div class="content-tags">
                        @for (tag of link.tags; track tag) {
                          <button
                            type="button"
                            class="content-tag tag-filter-chip"
                            [class.is-active]="isFilterActive(tag)"
                            [disabled]="loading || !!deletingLinkId"
                            [attr.aria-pressed]="isFilterActive(tag)"
                            [title]="tag"
                            (click)="toggleTagFilter(tag)">
                            {{ tag }}
                          </button>
                        }
                      </div>
                    } @else {
                      <span class="empty-tags">None</span>
                    }
                  </td>
                  <td class="rating-cell">{{ formatRating(link.rating) }}</td>
                  <td class="actions-cell">
                    <div class="row-actions">
                      <button
                        type="button"
                        class="ghost small icon-button"
                        aria-label="Edit link"
                        title="Edit link"
                        [disabled]="!!deletingLinkId"
                        (click)="openLink(link.id)">
                        <svg viewBox="0 0 24 24" aria-hidden="true">
                          <path
                            d="M4 20h4.75L19 9.75 14.25 5 4 15.25V20Zm2-2v-1.92l8.25-8.25 1.92 1.92L7.92 18H6ZM18.37 3.88l1.75 1.75a1.5 1.5 0 0 1 0 2.12l-.92.92-3.87-3.88.92-.91a1.5 1.5 0 0 1 2.12 0Z" />
                        </svg>
                      </button>
                      <button
                        type="button"
                        class="danger small icon-button"
                        [attr.aria-label]="deletingLinkId === link.id ? 'Deleting link' : 'Delete link'"
                        [attr.title]="deletingLinkId === link.id ? 'Deleting link' : 'Delete link'"
                        [disabled]="!!deletingLinkId"
                        (click)="deleteLink(link.id)">
                        <svg viewBox="0 0 24 24" aria-hidden="true">
                          <path
                            d="M9 3h6l1 2h4v2H4V5h4l1-2Zm1 6h2v8h-2V9Zm4 0h2v8h-2V9ZM7 9h2v8H7V9Zm1 12a2 2 0 0 1-2-2V8h12v11a2 2 0 0 1-2 2H8Z" />
                        </svg>
                      </button>
                    </div>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      } @else {
        <p class="empty-state">No links yet for this site. Create the first saved link to open the editor.</p>
      }
    </section>
  } @else {
    <section class="table-panel">
      <header class="table-panel-header">
        <div>
          <p class="eyebrow">Links</p>
          <h2>No sites available</h2>
        </div>
      </header>
      <p class="empty-state">Create a site first before managing links.</p>
    </section>
  }
</section>
